export default __webpack_public_path__ + "static/media/img_present.cf2f3569.jpg";